export const coverPhotoChoices = [
  {
    label: "Cover Photo 1",
    value: "https://ddxtzyivhaqjt.cloudfront.net/defaults/covers/cover1.jpeg",
  },
  {
    label: "Cover Photo 2",
    value: "https://ddxtzyivhaqjt.cloudfront.net/defaults/covers/cover2.jpeg",
  },
  {
    label: "Cover Photo 3",
    value: "https://ddxtzyivhaqjt.cloudfront.net/defaults/covers/cover3.jpeg",
  },
  {
    label: "Cover Photo 4",
    value: "https://ddxtzyivhaqjt.cloudfront.net/defaults/covers/cover4.jpeg",
  },
  {
    label: "Cover Photo 5",
    value: "https://ddxtzyivhaqjt.cloudfront.net/defaults/covers/cover5.jpeg",
  },
  {
    label: "Cover Photo 6",
    value: "https://ddxtzyivhaqjt.cloudfront.net/defaults/covers/cover6.jpeg",
  },
  {
    label: "Cover Photo 7",
    value: "https://ddxtzyivhaqjt.cloudfront.net/defaults/covers/cover7.jpeg",
  },
  {
    label: "Cover Photo 8",
    value: "https://ddxtzyivhaqjt.cloudfront.net/defaults/covers/cover8.jpeg",
  },
  {
    label: "Cover Photo 9",
    value: "https://ddxtzyivhaqjt.cloudfront.net/defaults/covers/cover9.jpeg",
  },
];
